<template>
  <div class="chat-image-modal tw-fixed tw-top-0 tw-left-0 tw-z-[51]">
    <div
      class="tw-w-screen tw-relative tw-h-screen tw-bg-black tw-bg-opacity-90 tw-flex tw-items-center tw-justify-center tw-text-white"
    >
      <img
        class="tw-w-full tw-h-full tw-max-w-[85vw] tw-max-h-[90vh] tw-object-contain"
        :src="image"
      />
      <button
        @click="onClose"
        class="tw-absolute tw-top-0 tw-right-0 tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-m-2 tw-border tw-border-white tw-rounded-md"
      >
        <svg
          class="tw-text-white tw-fill-current tw-h-5 tw-w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 320 512"
        >
          <!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
          <path
            d="M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"
          />
        </svg>
        <span>Close</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChatImageModal",
  props: {
    value: Boolean,
    image: String,
  },
  methods: {
    onClose() {
      this.$emit("close");
      this.$emit("input", false);
    },
  },
};
</script>

<style>

</style>
